import type { ZoneConnectionType } from "@/types"
import type { EmailTemplatedMessagesType } from "@/types/templated-messages"
import { ColumnDef } from "@tanstack/react-table"

import { DataTableColumnHeader } from "../../data-table"
import { EmailTemplatedMessagesOperations } from "../operations/edit-templated-messages-operations"

export const emailTemplatedMessagesColumns: ColumnDef<EmailTemplatedMessagesType>[] =
  [
    {
      accessorKey: "zone",
      header: ({ column }) => (
        <DataTableColumnHeader
          className="flex justify-center"
          column={column}
          title="Zone"
        />
      ),
      cell: ({ row }) => {
        const value = row.original.zone
        return (
          <div className="text-right md:mr-6 md:py-0 md:text-center">
            {value}
          </div>
        )
      },
    },
    {
      accessorKey: "due_reminder_type",
      header: ({ column }) => (
        <DataTableColumnHeader
          className="flex justify-center"
          column={column}
          title="Due Reminder Type"
        />
      ),
      cell: ({ row }) => {
        const value = row.original.due_reminder_type
        return (
          <div className="text-right md:mr-6 md:py-0 md:text-center">
            {value}
          </div>
        )
      },
    },
    {
      accessorKey: "subject",
      header: ({ column }) => (
        <DataTableColumnHeader
          className="flex justify-center"
          column={column}
          title="Subject"
        />
      ),
      cell: ({ row }) => {
        const value = row.original.subject
        return (
          <div className="text-right md:mr-6 md:py-0 md:text-center">
            {value}
          </div>
        )
      },
    },
    {
      accessorKey: "header",
      header: ({ column }) => (
        <DataTableColumnHeader
          className="flex justify-center"
          column={column}
          title="Header"
        />
      ),
      cell: ({ row }) => {
        const value = row.original.header
        return (
          <div className="text-right md:mr-6 md:py-0 md:text-center">
            {value}
          </div>
        )
      },
    },
    {
      accessorKey: "body",
      header: ({ column }) => (
        <DataTableColumnHeader
          className="flex justify-center"
          column={column}
          title="Body"
        />
      ),
      cell: ({ row }) => {
        const value = row.original.body
        return (
          <div className="text-right md:mr-6 md:py-0 md:text-center">
            {value}
          </div>
        )
      },
    },
    {
      accessorKey: "actions",
      header: () => {
        return <div className="text-center dark:text-white">Actions</div>
      },
      cell: ({ row }) => {
        return (
          <div className="px-4 py-2 text-center md:py-0 md:text-center">
            <EmailTemplatedMessagesOperations data={row.original} />
          </div>
        )
      },
    },
  ]
